import React, { useEffect } from 'react';
import FormContainer from '../../components/ui/FormContainer';
import { CheckCircle } from 'lucide-react';
import { saveProgress, completeOnboarding } from '../../utils/onboardingApi';

const OnboardingComplete = () => {
  // Ensure current_step is set to 'complete' and onboarding is marked done
  useEffect(() => {
    saveProgress('complete', { completedAt: new Date().toISOString() })
      .then(() => completeOnboarding())
      .catch(err => console.error('Failed to finalize onboarding:', err));
  }, []);

  return (
    <FormContainer maxWidth="max-w-2xl">
      <div className="text-center py-12 space-y-6">
        {/* Success Icon */}
        <div className="flex justify-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900">
          Onboarding Complete!
        </h1>

        {/* Message */}
        <div className="space-y-4 text-gray-600">
          <p className="text-lg">
            We look forward to connecting with you on your scheduled call.
          </p>
          <p>
            In the meantime, feel free to explore your CRM.
          </p>
        </div>
      </div>
    </FormContainer>
  );
};

export default OnboardingComplete;
